import React from 'react';

const NotFound = () => {
    return (
        <div className="d-flex justify-content-center align-items-center">
            <img src="https://image.freepik.com/free-vector/error-404-concept-illustration_114360-1811.jpg" alt="" />
        </div>
    );
};

export default NotFound;